// eslint-disable-next-line
export default (
  state = {
    projects: [],
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case 'GET_PROJECTS_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'GET_PROJECTS_SUCCESS':
      return {
        ...state,
        loading: false,
        projects: action.payload,
      };
    case 'GET_PROJECTS_FAILED':
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
